module.exports = __webpack_public_path__ + "static/media/lucide_audio-lines.de5d76ac.svg";